<template>
    <div class="loading">
        <b-loading :is-full-page="true" active></b-loading>
    </div>
</template>

<style lang="scss" scoped>
.loading {
    height: calc(100vh - 144px);
}
</style>

<script>
import { safeNext } from '../util/safeNext'

export default {
    name: 'Login',
    beforeMount() {
        const clientId = process.env.VUE_APP_DISCORD_CLIENT_ID
        const redirectURI = process.env.VUE_APP_REDIRECT_URL + `/authenticate`

        // Carried through Discord and back, so a link can say where it meant
        // to end up. The Activity's "view your rewards" uses it to land people
        // on their profile already signed in, rather than on a logged-out page
        // with a login button on it; so does a claim clicked while logged out.
        //
        // Validated on the way out as well as on the way back — this end knows
        // the value came from our own query string, and rejecting it here means
        // a bad one never reaches Discord at all.
        const next = safeNext(this.$route.query.next)

        const url = new URL('https://discord.com/oauth2/authorize')
        url.searchParams.set('client_id', clientId)
        url.searchParams.set('redirect_uri', redirectURI)
        url.searchParams.set('response_type', 'token')
        url.searchParams.set('scope', 'identify guilds')
        if (next) url.searchParams.set('state', next)

        window.location = url.toString()
    }
}
</script>
